<template>
  <vue-dialog :dialog-data="dialogData">
    <el-form label-width="90px" class="label-gray">
      <el-form-item label="当前权限" class="routes-tree-item">
        <el-tree :data="permissions"
                 :props="defaultProps"
                 default-expand-all
                 :indent="35"
                 :render-content="treeContent"
                 node-key="permissionId">
        </el-tree>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {getRoutesTree} from '@router/permission'
  export default {
    name: "RolePermission",
    props: {dialogData:Object},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        permissions: []
      }
    },
    created() {
      this.init();
    },
    methods: {
      treeContent(h, {data}) {
        return h("span", {class: data.icon}, data.label);
      },
      async init() {
        let row = this.dialogData.row;
        let nv = {role_id: row.id};
        let res = await this.$Http.getRolePermission(nv);
        if (res) {
          let list = this.getArray(res.data);
          this.permissions = getRoutesTree(list);
        }
      }
    }
  }
</script>

<style scoped>

</style>
